<template>
  <svg
    height="47"
    viewBox="0 0 45 47"
    width="45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      fill="#fff"
    ><path
      d="m0 .6976h44.3028v44.302h-44.3028z"
      fill="#fff"
      fill-rule="evenodd"
    /></mask>
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m44.3028 22.8486c0 12.235-9.917 22.151-22.151 22.151-12.235 0-22.152-9.916-22.152-22.151 0-12.232 9.917-22.151 22.152-22.151 12.234 0 22.151 9.919 22.151 22.151"
        fill="#fff"
        mask="url(#a)"
        transform="translate(0 .3028)"
      />
      <path
        d="m22.1514 45.0098c12.073 0 21.86-9.786 21.86-21.859h-43.721c0 12.073 9.788 21.859 21.861 21.859"
        fill="#d41d3b"
      />
      <path
        d="m22.1514 1.2891c-12.073 0-21.861 9.788-21.861 21.861h43.721c0-12.073-9.787-21.861-21.86-21.861"
        fill="#e9e8e7"
      />
    </g>
  </svg>
</template>
